import urlConstants from '../constants/urlConstants';
import cleanRichText from './cleanRichText';

// Deze site is alleen voor 12 tot en met 18 jaar. Vragen over YoungLeaders
// (18-30) tonen we niet, en een paar verouderde antwoorden vervangen we.
const hidden = [
  /youngleaders/i,
  /in aanmerking te komen voor subsidie/i,
  // Verhalen van deelnemers van 19 tot en met 30 jaar, zoals "Olivia 20 jaar".
  /\b(19|2\d|30) jaar\b/,
];

const text = (value) => ({
  nodeType: 'text', value, marks: [], data: {},
});
const link = (uri, value) => ({
  nodeType: 'hyperlink', data: { uri }, content: [text(value)],
});
const paragraph = (...content) => ({ nodeType: 'paragraph', data: {}, content });
const doc = (...content) => ({ nodeType: 'document', data: {}, content });

const answers = {
  'Is het programma er ook voor volwassenen?': doc(
    paragraph(
      text('Dit programma is voor jongeren van 12 tot en met 18 jaar. Ben je tussen de 18 en 30 jaar? Kijk dan bij '),
      link(urlConstants.JONGVOLWASSENEN_SITE, 'InsideOut Jongvolwassenen'),
      text('.'),
    ),
    paragraph(text('Voor ouders en andere opvoeders is er de training '), link(urlConstants.OPVOEDERS_SITE, 'Hart voor opvoeden'), text('.')),
  ),
  'Wanneer vinden de bijeenkomsten plaats?': doc(
    paragraph(
      text('De bijeenkomsten van InsideOut vinden op verschillende momenten in het jaar plaats. Op de pagina met '),
      link(urlConstants.DATA, 'data'),
      text(' vind je de eerstvolgende startdata. Heb je vragen? '),
      link(urlConstants.CONTACT, 'Neem contact met ons op'),
      text('.'),
    ),
  ),
};

const mdtCosts = doc(
  paragraph(text('De programmawaarde is €2.150 per deelnemer. Dankzij de MDT-subsidie van de Rijksoverheid is deelname kosteloos voor jongeren die aan de voorwaarden voldoen.')),
  paragraph(text('Na afloop ontvang je een MDT-certificaat. Daarmee laat je zien dat je je maatschappelijk hebt ingezet en aan jezelf hebt gewerkt: mooi voor je cv of je aanmelding voor een vervolgopleiding.')),
  paragraph(text('Tijdens de voorlichting of een kennismakingsgesprek bekijken we samen wat voor jou geldt. Vragen? '), link(urlConstants.CONTACT, 'Neem contact met ons op'), text('.')),
);

answers['Wat kost het om deel te nemen?'] = mdtCosts;
answers['Ik wil graag meedoen maar ik heb het geld niet. Wat nu?'] = doc(
  paragraph(text('Geld hoeft geen reden te zijn om niet mee te doen. Dankzij de MDT-subsidie is deelname kosteloos voor jongeren die aan de voorwaarden voldoen.')),
  paragraph(text('Twijfel je of dat voor jou geldt? '), link(urlConstants.CONTACT, 'Neem contact met ons op'), text(', dan kijken we samen wat er mogelijk is.')),
);
answers['Waar worden de bijeenkomsten gehouden?'] = doc(
  paragraph(text('De bijeenkomsten vinden plaats in de omgeving van Haarlem of Almere.')),
  paragraph(text('Op aanvraag verzorgen we het programma ook op scholen of voor een eigen groep, op een passende locatie.')),
);

export const isHiddenQuestion = (question) => hidden.some((re) => re.test(question || ''));

// Extra alinea's onder bestaande antwoorden uit het CMS.
const additions = {
  'Wat voor ondersteuning bieden jullie aan opvoeders?': paragraph(
    text('Meer weten? Lees alles over de training op de '),
    link(urlConstants.OPVOEDERS_SITE, 'pagina voor opvoeders'),
    text('.'),
  ),
};

export const answerFor = (question, answer) => {
  if (answers[question]) return answers[question];
  const cleaned = cleanRichText(answer);
  const extra = additions[question];
  return extra && cleaned ? { ...cleaned, content: [...cleaned.content, extra] } : cleaned;
};
